export default __webpack_public_path__ + "static/media/menu-dots.09f4858f.svg";